(function () {
  "use strict";
  function init(widget) {
    const input = widget.querySelector('[data-lo-qty]');
    const total = widget.querySelector('[data-lo-total]');
    const detail = widget.querySelector('[data-lo-detail]');
    const quick = widget.querySelectorAll('[data-lo-quick]');
    const checkout = widget.querySelector('[data-lo-checkout]');
    const ref = widget.querySelector('[data-lo-reference]');
    const banner = widget.querySelector('[data-lo-demo-message]');
    const variantId = widget.getAttribute('data-variant-id') || '';
    const state = widget.getAttribute('data-state') || 'unavailable';
    const priceCents = Number(widget.getAttribute('data-price-cents') || '100');
    const maxQty = 9999;
    const money = new Intl.NumberFormat('en-US', {style:'currency', currency:'USD', minimumFractionDigits:2});
    function qty() {
      const value = Number.parseInt(input.value, 10);
      return Number.isFinite(value) ? Math.max(1, Math.min(maxQty, value)) : 1;
    }
    function render() {
      const count = qty();
      total.textContent = money.format(count * priceCents / 100);
      detail.textContent = count.toLocaleString('en-US') + ' × ' + money.format(priceCents / 100);
      quick.forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.loQuick) === count)); });
    }
    function update(count) {input.value = Math.min(maxQty, Math.max(1, count)); render();}
    widget.querySelector('[data-lo-minus]').addEventListener('click', function(){update(qty()-1);});
    widget.querySelector('[data-lo-plus]').addEventListener('click', function(){update(qty()+1);});
    quick.forEach(function(b){b.addEventListener('click', function(){update(Number(b.dataset.loQuick));});});
    input.addEventListener('input', render);
    input.addEventListener('change', function(){update(qty());});
    function base64url(object) {
      const array = new TextEncoder().encode(JSON.stringify(object));
      let binary = '';
      array.forEach(function (n) {binary += String.fromCharCode(n);});
      return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }
    checkout.addEventListener('click', function(){
      update(qty());
      if (state === 'demo') {
        if (banner) {banner.textContent = 'Preview only — no payment was created. After the theme is published and the $1 physical product is configured, this button will open the real Shopify checkout.'; banner.hidden = false;}
        return;
      }
      if (state !== 'ready' || !/^[0-9]+$/.test(variantId)) {return;}
      const count = qty();
      const reference = ref.value.trim().slice(0, 80);
      let path = '/cart/' + encodeURIComponent(variantId) + ':' + count;
      // Shopify's official cart permalink format goes straight to hosted checkout.
      if (reference) {path += '?properties=' + encodeURIComponent(base64url({'TikTok username':reference}));}
      window.location.assign(path);
    });
    render();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lo-widget]').forEach(init);
  });
})();
